/**
* @Author: zachalam
* @Date:   2017-03-13T16:47:12-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-17T11:48:32-07:00
*/

import React, { Component } from 'react';

import Container from '../../blocks/Container';
import Panel from '../../common/Panel';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions, box } from '../../../style';
import Button from '../../blocks/Button';



class BillingPending extends Component {

  render() {

      return (
        <div>
        <Container screenTop>
          <Panel>
          <h1 className="title-size3 pageHeader-title">
          We're still processing your payment!
          </h1>
          <p className="pageHeader-description"> 
          Please check back in 10 minutes or contact <a href="https://www.misstravel.com/contact-us"><u>customer support</u></a>. 
          </p>
          <Button to={'/dashboard'} variant={'primary'}>Back to Dashboard</Button>
          </Panel>

        </Container>
        </div>
      );

    }
}



export default BillingPending;



// WEBPACK FOOTER //
// ./src/components/pages/Billing/BillingPending.jsx